module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "p-reset"
  }, [(_vm.changed) ? _c('el-form', [_vm._v("\n    " + _vm._s(_vm.$t('pages.account.resetSuccess')) + "\n    "), _c('el-button', {
    on: {
      "click": _vm.backToLogin
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.account.back_to_login')))])], 1) : _c('el-form', {
    ref: "resetForm",
    attrs: {
      "model": _vm.userReset,
      "rules": _vm.resetPasswordRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.oldPassword'),
      "prop": "current_password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.userReset.current_password),
      callback: function($$v) {
        _vm.$set(_vm.userReset, "current_password", $$v)
      },
      expression: "userReset.current_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.password'),
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.userReset.password),
      callback: function($$v) {
        _vm.$set(_vm.userReset, "password", $$v)
      },
      expression: "userReset.password"
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "random-psw"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.createRandomPassword()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.random_password')))]), _vm._v(" "), _c('code', [_vm._v(_vm._s(_vm.randomPassword))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.confirmPassword'),
      "prop": "confirm_password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.userReset.confirm_password),
      callback: function($$v) {
        _vm.$set(_vm.userReset, "confirm_password", $$v)
      },
      expression: "userReset.confirm_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitResetPassword
    }
  }, [_vm._v(_vm._s(_vm.$t('common.resetPassword')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71c07e57"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Account.vue
// module id = 388
// module chunks = 1